class Slider {
  constructor(selector, options = {}) {
    this.slider = document.querySelector(selector);
    if (!this.slider) return;

    this.slides = this.slider.querySelectorAll('.slide');
    this.slideMax = this.slides.length;

    this.sliderPrev = this.slider.querySelector('.slider-prev');
    this.sliderNext = this.slider.querySelector('.slider-next');
    this.sliderController = this.slider.querySelector('.slider-controls');

    this.options = Object.assign(
      {
        keyboard: false,
        pagination: false,
        clickable: false,
        labelSlider: 'Slider',
        labelPrev: 'Previous',
        labelNext: 'Next',
        labelSlide: 'Slide {index}',
        labelDot: 'Go to slide {index}',
        // ここ重要: ボタンに文字を入れない (CSS の ::before 矢印を使う)
        buttonPrev: '',
        buttonNext: ''
      },
      options
    );

    this.init();
  }

  init() {
    if (!this.sliderPrev || !this.sliderNext || !this.sliderController) return;

    this.sliderPrev.disabled = true;
    this.currentSlideIndex = 0;

    if (this.options.pagination) {
      this.createPagination();
    }

    this.setupIntersectObserver();
    this.setupArrowNavigation();

    if (this.options.keyboard) {
      this.setupKeyboardNavigation();
    }

    this.addWaiAria();
    this.setupButtons();
    this.updateButtonStates();
  }

  addWaiAria() {
    this.slider.setAttribute('aria-label', this.options.labelSlider);
    this.slider.setAttribute('role', 'region');

    this.sliderPrev.setAttribute('aria-label', this.options.labelPrev);
    this.sliderNext.setAttribute('aria-label', this.options.labelNext);

    if (this.options.pagination) {
      const dots = this.slider.querySelectorAll('.dot');
      dots.forEach((dot, index) => {
        const dotLabel = this.options.labelDot.replace('{index}', index + 1);
        dot.setAttribute('aria-label', dotLabel);
      });
    }

    this.slides.forEach((slide, index) => {
      const slideLabel = this.options.labelSlide.replace('{index}', index + 1);
      slide.setAttribute('aria-label', slideLabel);
    });
  }

  setupButtons() {
    // 文字を入れない (入れる場合だけ設定)
    if (this.options.buttonPrev !== undefined) this.sliderPrev.innerHTML = this.options.buttonPrev;
    if (this.options.buttonNext !== undefined) this.sliderNext.innerHTML = this.options.buttonNext;
  }

  createPagination() {
  // 既にHTML側に .slider-dots があるならそれを使う
  this.sliderDots = this.slider.querySelector('.slider-dots');
  if (!this.sliderDots) {
    this.sliderDots = document.createElement('div');
    this.sliderDots.classList.add('slider-dots');
    this.sliderController.appendChild(this.sliderDots);
  }

  // 中身は毎回クリアして作り直す
  this.sliderDots.innerHTML = '';

  this.slides.forEach((slide, index) => {
    const dot = document.createElement('span');
    dot.classList.add('dot');
    dot.setAttribute('data-slide', index);

    if (index === 0) dot.classList.add('current');

    if (this.options.clickable) {
      this.sliderDots.setAttribute('data-clickable', true);
      dot.addEventListener('click', () => {
        this.goToSlide(index);
        this.updateButtonStates();
      });
    }

    this.sliderDots.appendChild(dot);
  });
}


  setupIntersectObserver() {
    const options = {
      root: this.slider.querySelector('.slider-main'),
      rootMargin: '0px -50%',
      threshold: 0
    };

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), options);
    this.slides.forEach((slide) => this.observer.observe(slide));
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const currentIndex = Array.from(this.slides).indexOf(entry.target);
        if (currentIndex !== this.currentSlideIndex) {
          this.currentSlideIndex = currentIndex;
          this.updateButtonStates();
        }
      }
    });
  }

  activatePagination(targetSlide) {
    const newIndex = Array.from(this.slides).indexOf(targetSlide);
    const current = this.slider.querySelector('.dot.current');
    if (current) current.classList.remove('current');

    const next = this.slider.querySelector(`.dot[data-slide="${newIndex}"]`);
    if (next) next.classList.add('current');
  }

  setupArrowNavigation() {
    this.slider.addEventListener('click', (event) => {
      const target = event.target.closest('.slider-prev, .slider-next');
      if (!target) return;

      const direction = target.classList.contains('slider-prev') ? 'prev' : 'next';
      this.navigateSlides(direction);
    });
  }

  navigateSlides(direction) {
    let newIndex;
    if (direction === 'prev') {
      this.currentSlideIndex = Math.max(0, this.currentSlideIndex - 1);
      newIndex = this.currentSlideIndex;
    } else {
      this.currentSlideIndex = Math.min(this.slideMax - 1, this.currentSlideIndex + 1);
      newIndex = this.currentSlideIndex;
    }

    this.goToSlide(newIndex);
    this.updateButtonStates();
  }

  goToSlide(index) {
    const targetSlide = this.slides[index];
    if (!targetSlide) return;

    targetSlide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });

    if (this.options.pagination) {
      this.activatePagination(targetSlide);
    }
  }

  updateButtonStates() {
    if (this.sliderPrev) this.sliderPrev.disabled = this.currentSlideIndex === 0;
    if (this.sliderNext) this.sliderNext.disabled = this.currentSlideIndex === this.slideMax - 1;
  }

  setupKeyboardNavigation() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') this.navigateSlides('prev');
      if (event.key === 'ArrowRight') this.navigateSlides('next');
    });
  }
}
